export const categories = [
  { id: 1, name: "IFC & CORENET X Courses", infoType: "categories" },
  { id: 2, name: "Autodesk Courses", infoType: "categories" },
  { id: 3, name: "Bentley Courses", infoType: "categories" },
  { id: 4, name: "BIM Courses", infoType: "categories" },
  { id: 5, name: "SkillsFuture Courses", infoType: "categories" },
  { id: 6, name: "1-Day Short Courses", infoType: "categories" },
]

export const categoriesFilterProp = [
  "ifc",                    // 1: IFC & CORENET X Courses
  "autodesk",               // 2: Autodesk Courses
  "bentley",                // 3: Bentley Courses
  "bim",                    // 4: BIM Courses
  "SkillsFuture",           // 5: SkillsFuture Courses (case sensitive!)
  "short-courses",          // 6: 1-Day Short Courses
]

export const prices = [
  { id: 1, name: "Free", infoType: "prices" },
  { id: 2, name: "$0 - $49", infoType: "prices" },
  { id: 3, name: "$50 - $99", infoType: "prices" },
  { id: 4, name: "$100 - $499", infoType: "prices" },
  { id: 5, name: "$500 - $999", infoType: "prices" },
  { id: 6, name: "$1000 above", infoType: "prices" },
]

export const pricesFilterProps = [
  "free",
  "0To49",
  "50To99",
  "100To499",
  "500To999",
  "moreThan1000",
]